import * as tslib_1 from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import cn from 'astro-classname';
import omit from 'lodash/omit';
import '../radio/index.css';
var BLACK_LIST = [
    'className',
    'prefix',
    'disabled',
    'onChange',
    'value'
];
var Group = (function (_super) {
    tslib_1.__extends(Group, _super);
    function Group() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onChange = function (e) { return _this.props.onChange(e); };
        return _this;
    }
    Group.prototype.getChildContext = function () {
        var _a = this.props, disabled = _a.disabled, value = _a.value;
        return {
            radioGroup: {
                value: value,
                disabled: disabled,
                onChange: this._onChange
            }
        };
    };
    Group.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, prefix = _a.prefix;
        var classes = cn(className, prefix + "-group");
        var nodeProps = omit(this.props, BLACK_LIST);
        return (React.createElement("div", tslib_1.__assign({ className: classes }, nodeProps), children));
    };
    Group.defaultProps = {
        className: '',
        onChange: function () { return null; },
        disabled: false,
        prefix: 'zhui-radio'
    };
    Group.childContextTypes = {
        radioGroup: PropTypes.any,
    };
    return Group;
}(React.Component));
export default Group;
